import ReplayIcon from '@mui/icons-material/Replay';
import { Box, Button, Stack, Typography } from '@mui/material';

import { AdminCheckbox } from 'src/components/NodeSaleForm/AdminCheckbox';
import { themeMap } from 'src/global/constants/theme.constant';
import { ProjectTheme } from 'src/global/enums/project.enum';
import { colors } from 'src/global/styles/colors';
import { useTheme } from 'src/provider/ThemeCustomizationProvider';

import { SectionAccordion } from './SectionAccordion';

export default function ThemeMode() {
  const { selectedThemeMode, setSelectedThemeMode, resetToDefault, updateTheme } = useTheme();
  const modes = [
    {
      label: 'Light',
      value: ProjectTheme.LIGHT,
      imgUrl: '/imgs/theme-mode/light-mode.png',
    },
    {
      label: 'Dark',
      value: 'dark',
      imgUrl: '/imgs/theme-mode/dark-mode.png',
    },
  ];
  return (
    <Box padding={'12px 24px 24px 24px'} borderBottom={`1px solid ${colors.neutral015}`}>
      <SectionAccordion
        title='Theme Mode'
        bodyContent={
          <Box width={'100%'}>
            <Stack width={'100%'} direction={'row'} justifyContent={'space-between'} spacing={2}>
              {modes.map((mode, index) => (
                <Box
                  key={index}
                  width={'50%'}
                  sx={{
                    borderRadius: '4px',
                    border: `1px solid ${colors.neutral015}`,
                    cursor: 'pointer',
                  }}>
                  <Stack
                    direction={'row'}
                    justifyContent={'end'}
                    width={'100%'}
                    marginTop={2}
                    borderBottom={`1px solid ${colors.neutral015}`}>
                    <img
                      style={{
                        width: '90%',
                      }}
                      src={mode.imgUrl}
                      width={'90%'}
                      height={'auto'}
                      alt='mode'
                    />
                  </Stack>
                  <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'} padding={'0 16px'}>
                    <Typography fontSize={'14px'} lineHeight={'20px'} sx={{ color: 'white' }}>
                      {mode.label}
                    </Typography>
                    <AdminCheckbox
                      value={mode.value}
                      checked={mode.value === selectedThemeMode}
                      onChange={e => {
                        setSelectedThemeMode(e.target.value as ProjectTheme);
                        updateTheme(themeMap[e.target.value as ProjectTheme]);
                      }}
                    />
                  </Stack>
                </Box>
              ))}
            </Stack>
            <Button
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                marginTop: '16px',
              }}
              onClick={() => resetToDefault()}>
              <ReplayIcon sx={{ color: 'white' }} />
              <Typography fontSize={'14px'} lineHeight={'20px'} sx={{ color: 'white' }}>
                Reset to default
              </Typography>
            </Button>
          </Box>
        }
      />
    </Box>
  );
}
